
import Vue from 'vue';
import { Line } from '@/models/math.model';

export default Vue.extend({
    name: 'CloseIcon',
    props: {
        background: {
            type: String,
            default: 'white',
        },
        circleBorderColor: {
            type: String,
            default: 'black',
        },
        circleBorderWidth: {
            type: String,
            default: '3px',
        },
        circleCrossColor: {
            type: String,
            default: 'black',
        },
        lineWidth: {
            type: String,
            default: '3px',
        },
        lineLength: {
            type: Number,
            default: 20,
        },
        lineCap: {
            type: String,
            default: 'butt',
        },
    },
    data() {
        return {
            lineOne: null as null | Line,
            lineTwo: null as null | Line,
        };
    },
    methods: {
        calcCrossSize() {
            const SVG_SIZE = 42.5;
            const LINE = this.lineLength;
            const lineOne = {
                x1: (SVG_SIZE - LINE) / 2,
                y1: (SVG_SIZE - LINE) / 2,
                x2: (SVG_SIZE - LINE) / 2 + LINE,
                y2: (SVG_SIZE - LINE) / 2 + LINE,
            };
            const lineTwo = {
                x1: (SVG_SIZE - LINE) / 2 + LINE,
                y1: (SVG_SIZE - LINE) / 2,
                x2: (SVG_SIZE - LINE) / 2,
                y2: (SVG_SIZE - LINE) / 2 + LINE,
            };
            this.lineOne = lineOne;
            this.lineTwo = lineTwo;
        },
    },
    created() {
        this.calcCrossSize();
    },
});
